/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Bell({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.47 13.1H3.039a1.6 1.6 0 0 1-1.462-2.25l1.03-2.318a3.4 3.4 0 0 0 .293-1.38V6a5.1 5.1 0 0 1 10.2 0v1.151c0 .476.1.946.293 1.381l1.03 2.318a1.6 1.6 0 0 1-1.462 2.25h-2.43a2.6 2.6 0 0 1-5.061 0ZM4.1 6a3.9 3.9 0 0 1 7.8 0v1.151a4.6 4.6 0 0 0 .396 1.868l1.03 2.319a.4.4 0 0 1-.365.562H3.04a.4.4 0 0 1-.366-.563l1.03-2.318A4.6 4.6 0 0 0 4.1 7.151V6Zm2.635 7.1a1.4 1.4 0 0 0 2.53 0h-2.53Z" clipRule="evenodd" /></svg>;
}
;